export const advancedSearch = {
  advancedSearch: {
    info: 'Before requesting a quote based on product attributes, please browse our online catalog to find the right motor for your need.',

    form: {
      product_line: {
        label: 'Product Line',
      },
      speed_rpm: {
        label: 'Speed RPM',
      },
      output_hp: {
        label: 'Output HP',
      },
      voltage: {
        label: 'Voltage (V)',
      },
      frame_size: {
        label: 'Frame Size',
      },
      output_kw: {
        label: 'Output KW',
      },
      mounting: {
        label: 'Mounting',
      },
      phase: {
        label: 'Phase',
      },
      enclosure: {
        label: 'Enclosure',
      },
      application: {
        label: 'Application',
      },
      actions: {
        search: {
          label: 'Search',
        },
      },
    },

    noContent:
      'No product found with the requested attributes. Request a quote if you would like us to evaluate it again.',
  },
};
